import Vue from "vue";
import VueRouter from "vue-router";
import homePage from "@/Pages/HomePage";

import workWithUs from "@/Pages/workWithUs";
import ourServices from "@/Pages/OurServices";
import ourCertificates from "@/Pages/OurCertificates";
import contactUs from "@/Pages/ContactUs";
import aboutUs from "@/Pages/AboutUs";
import allProducts from "@/components/AllProducts";
import allProductDetail from "@/components/AllProductDetail";
import isokiaKashani from "@/Pages/IsokiaKashani";
Vue.use(VueRouter);

const routes = [
  {
    path: "/HomePage",
    name: "HomePage",
    component: homePage,
    meta: {transition: 'fade-in-up'},

  },
  {
    path: '/',
    redirect: '/HomePage',
    meta: {transition: 'fade-in-up'},
  },
  {
    path: "/isokiaKashani",
    name: "isokiaKashani",
    component: isokiaKashani,
    meta: {transition: 'fade-in-up'},
  },
  {
    path: "/workWithUs",
    name: "workWithUs",
    component: workWithUs,
    meta: {transition: 'fade-in-up'},
  },
  {
    path: "/OurServices",
    name: "OurServices",
    component: ourServices,
    meta: {transition: 'fade-in-up'},
  },
  {
    path: "/ourCertificates",
    name: "ourCertificates",
    component: ourCertificates,
    meta: {transition: 'fade-in-up'},
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: contactUs,
    meta: {transition: 'fade-in-up'},
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: aboutUs,
    meta: {transition: 'fade-in-up'},
  },
  {
    path: "/allProducts",
    name: "allProducts",
    component: allProducts,
    meta: {transition: 'fade-in-up'},
  },
  {
    path: "/allProductDetail",
    name: "allProductDetail",
    component: allProductDetail,
    meta: {transition: "zoom"},
  },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
